<template>
<!-- 添加:key="$route.fullPath"路由地址不变参数变化刷新 -->
  <router-view :key="$route.fullPath" /> 
</template>

<style lang="scss">
#app {
  font-family:"微软雅黑", Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
